export default {
    routerName: '岗位详情',
    post: {
        name: '岗位名',
        code: '岗位号',
        sortOrder: '排序',
        status: '状态',
        open: '启用',
        close: '停用',
        createBy: '创建者',
        createTime: '创建时间',
        updateBy: '更新者',
        updateTime: '更新时间',
        remark: '备注',
    },
};
